"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LabelledRadio;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _form = require("@sharingapples/form");

function LabelledRadio(props) {
  var options = props.options,
      name = props.name,
      hideLabel = props.hideLabel,
      label = props.label,
      showReset = props.showReset,
      rest = (0, _objectWithoutProperties2["default"])(props, ["options", "name", "hideLabel", "label", "showReset"]);

  var _useFormInput = (0, _form.useFormInput)(name),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      value = _useFormInput2[0],
      onChange = _useFormInput2[1];

  var onReset = function onReset() {
    return onChange(null);
  };

  var handleChange = _react["default"].useCallback(function (e) {
    return onChange(e.target.value);
  }, [onChange]);

  return _react["default"].createElement("div", (0, _extends2["default"])({
    role: "radiogroup",
    "aria-label": label || props['aria-label']
  }, rest), label && _react["default"].createElement("label", null, label), showReset && _react["default"].createElement("span", {
    className: "float-right c-pointer",
    onClick: onReset,
    style: {
      color: '#adadad'
    }
  }, "Reset"), options.map(function (option) {
    var label = option.label,
        rest = (0, _objectWithoutProperties2["default"])(option, ["label"]);
    return _react["default"].createElement(_reactstrap.CustomInput, (0, _extends2["default"])({
      key: label,
      type: "radio",
      id: label,
      name: label,
      label: label,
      onChange: handleChange,
      checked: value === option.value
    }, rest));
  }));
}